var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'login': !_vm.getToken,
},attrs:{"id":"app"}},[(_vm.getToken)?[_c('div',{staticClass:"ui",class:{
            open: _vm.isSidebarOpen,
        }},[_c('div',{staticClass:"sidebar-wrapper"},[_c('div',{staticClass:"sidebar"},[_c('div',[_c('Sidebar')],1)])]),_c('div',{staticClass:"viewport"},[_c('Navigation'),_c('InterfaceMessage'),_c('main',[_c('router-view')],1)],1)])]:[_c('Login')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }